import { Grid, IconButton } from "@mui/material"
import { ISettingsItem, useSettings } from "../../Settings"
import { ReactComponent as InstagramIcon } from '../../assets/icons/footerSocials/Instagram.svg'
import { ReactComponent as MessengerIcon } from '../../assets/icons/footerSocials/Messenger.svg'
import { ReactComponent as LinkedinIcon } from '../../assets/icons/footerSocials/Linkedin.svg'

export default function FooterSocials({ name }: ISettingsItem) {
  const { socials } = useSettings()

  const navButtons = [
    { socialIcon: <InstagramIcon />, link: socials?.instagram },
    { socialIcon: <MessengerIcon />, link: socials?.messenger },
    { socialIcon: <LinkedinIcon />, link: socials?.linkedin },
  ]

  return (
    <Grid item className={name ? `${name} footer-socials` : "footer-socials"}>
      {navButtons
        .filter(({ link }) => link && link.trim() !== "")
        .map(({ link, socialIcon }, index) => (
          <IconButton
            key={index}
            component="a"
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`social-link-${index}`}
          >
            {socialIcon}
          </IconButton>
        ))}
    </Grid>
  )
}
